// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"bccfbe9a","238":"6aad3a08","311":"8e3614d4","383":"465b6104","397":"cef13f94","413":"6443ef6e","467":"2d8900b2","479":"9fe5b2bf","482":"6cbf5617","743":"0fc59909","815":"1238385b"}[chunkId] + ".chunk.js";
};